import { render, staticRenderFns } from "./customer-summary.vue?vue&type=template&id=b9bc8918&"
import script from "./customer-summary.vue?vue&type=script&lang=js&"
export * from "./customer-summary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports